module.exports = __webpack_public_path__ + "img/OK-alt.6d24fc68.svg";